export default __webpack_public_path__ + "components/weather-icon/static/daymodrain-61cade530f266efdb9e573e60f914e10.png";